// extracted by mini-css-extract-plugin
export default {"formCarousel":"Pager_formCarousel__k2vY4"};